import getLoadBalancedUrl from 'utils/cdn/getLoadBalancedUrl';

const getSrc = (url: string) => {
  if (!url) {
    return null;
  }

  const regex = /.*\/\/[^/]*(\/.*)$/;
  const match = RegExp(regex).exec(url);
  const s3Path = match ? match[1] : '';

  if (!s3Path) {
    return url;
  }

  return getLoadBalancedUrl(url, s3Path);
};

export default getSrc;
